import React from 'react';

const RupeeSymbol = ({ className, style }) => {
  return (
    <span 
      className={className}
      style={{ 
        fontFamily: 'Noto Sans, sans-serif', 
        fontWeight: 400,
        ...style
      }}
    >
      ₹
    </span>
  );
};

export default RupeeSymbol;

